










import { defineComponent } from "@vue/composition-api";
import BasePage from "@/components/BasePage";
import LoginComponent from "@/components/LoginComponent";

export default defineComponent({
  name: "PageLogin",
  components: { BasePage, LoginComponent },
});
